module.exports = __webpack_public_path__ + "9ada053049f0acaa3e6c9c989b17e9b7.pdf";